export const DELETE_USER: 'DELETE_USER' = 'DELETE_USER';
export const DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS' = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL: 'DELETE_USER_FAIL' = 'DELETE_USER_FAIL';
export const SET_COMPLETION_PERCENT: 'user/SET_COMPLETION_PERCENT' = 'user/SET_COMPLETION_PERCENT';
export const TOGGLE_ENLIST_USER: 'user/TOGGLE_ENLIST_USER' = 'user/TOGGLE_ENLIST_USER';
export const FETCH_STATS_SHARING: 'user/FETCH_STATS_SHARING' = 'user/FETCH_STATS_SHARING';
export const SAVE_STATS_SHARING: 'user/SAVE_STATS_SHARING' = 'user/SAVE_STATS_SHARING';
export const SET_NO_MORE_INSTACONNECT: 'user/NO_MORE_RENEW_INSTACONNECT' = 'user/NO_MORE_RENEW_INSTACONNECT';
export const SET_LEGAL_TERM_SIGNATURE: 'user/SET_LEGAL_TERM_SIGNATURE' = 'user/SET_LEGAL_TERM_SIGNATURE';
